module.exports = __webpack_public_path__ + "media/images/top/feature/feature-2-754e863d087472c9f466fd346f221726.png";